<template>
  <div v-loading="loading" ref="chartDom" style="height: 100%; min-height: 320px" />
</template>

<script>
let echarts = require('echarts')
let elementResizeDetectorMaker = require("element-resize-detector")
export default {
  data () {
    return {
      loading: false,
      queryParams: this.params || {}
    }
  },
  props: {
    params: { type: Object }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      if (this.loading) { return }
      this.loading = true
      let that = this
      that.$apis.trend.purchaser.ranking(that.queryParams).then(res => {
        let option = {
          title: {
            text: '采购单位排名 TOP10',
            subtext: `${this.queryParams.category || '全部品类'} ${this.queryParams.region || '全部地区'}`
          },
          legend: {
            type: 'scroll',
            itemGap: 24,
            formatter: function (name) {
              if (name.length > 20) {
                name = name.slice(0, 20) + '...'
              }
              return name
            },
            orient: 'vertical',
            bottom: 0,
            left: 0,
            selected: {
              "其它": false
            }
          },
          series: [
            {
              type: 'pie',
              data: res.items,
              radius: '50%',
              center: ['60%', '50%'],
              minAngle: 10,
              avoidLabelOverlap: true,
              label: {
                formatter: '{b}\n采购{c}万\n占比{d}%'
              },
              labelLine: {
                length: 50
              }
            }
          ]
        }
        const chart = that.$refs['chartDom']
        if (chart) {
          let myChart = echarts.init(chart)
          myChart.setOption(option)

          // 点击事件
          myChart.on('click', function (params) {
            that.$router.push({ path: "detail", query: { ...that.params, purchaser: params.name } })
          })
          //刷新响应
          elementResizeDetectorMaker().listenTo(chart, function () {
            myChart.resize()
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>